import { Icon } from '@livable/saas-react-components';
import { Button, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FinancialTextInput from 'src/components/shared/FinancialTextInput';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import useCustomFeeStyles from './styles';
const CustomFee = props => {
  const customFee = props.customFee,
    description = props.description,
    feeText = props.feeText,
    feeValue = props.feeValue,
    handleDiscardClick = props.handleDiscardClick,
    handleEditClick = props.handleEditClick,
    handleRelink = props.handleRelink,
    handleSaveClick = props.handleSaveClick,
    handleSignChange = props.handleSignChange,
    label = props.label,
    lateFee = props.lateFee,
    isOpened = props.isOpened,
    padding = props.padding,
    placeholder = props.placeholder,
    handleInputChange = props.handleInputChange,
    sign = props.sign,
    title = props.title;
  const classes = useCustomFeeStyles({
    backgroundColor: customFee !== null && customFee >= 0 ? 'info' : 'warning',
    label,
    padding
  });
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.feeBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coins-in-hand"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.labels
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, title !== null && title !== void 0 ? title : "".concat(lateFee ? 'Late' : 'Admin', " fee"), ": ", feeText), customFee === null ? null : /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, description))), isOpened ? /*#__PURE__*/React.createElement("div", {
    className: classes[lateFee ? 'lateFeeButtons' : 'inputField']
  }, lateFee ? /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    className: classes.signToggler,
    exclusive: true,
    onChange: handleSignChange,
    value: sign
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: FEE_UNIT_TYPES.fixedAmount
  }, "$"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: FEE_UNIT_TYPES.percentage
  }, "%")) : null, /*#__PURE__*/React.createElement(FinancialTextInput, {
    handleInputChange: handleInputChange,
    inputLabel: t('unit_modal.custom_fee'),
    percentageSign: lateFee && sign === FEE_UNIT_TYPES.percentage,
    percentSignOnRight: true,
    placeholder: placeholder,
    refresh: true,
    valueExt: feeValue,
    withAdorment: true
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.inputField
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleEditClick,
    size: "medium",
    variant: "actionIcon",
    'custom-attribute': '309-CustomFee'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), label))), isOpened ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.feeRelink
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.feeRelinkText
  }, /*#__PURE__*/React.createElement(Icon, {
    type: customFee !== null && customFee >= 0 ? 'relink' : 'unlink'
  }), /*#__PURE__*/React.createElement(Typography, {
    margin: "0 10px",
    variant: "h6"
  }, t("unit_modal.fee_".concat([customFee !== null && customFee >= 0 ? 'relink' : 'unrelink'])))), customFee !== null && customFee >= 0 ? /*#__PURE__*/React.createElement(Button, {
    onClick: handleRelink,
    size: "medium",
    variant: "actionIcon",
    'custom-attribute': '310-CustomFee'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "relink"
  }), "Re-link") : null), /*#__PURE__*/React.createElement("div", {
    className: classes.feeFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.feeFooterButtons
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleDiscardClick,
    size: "medium",
    variant: "text",
    'custom-attribute': '311-CustomFee'
  }, "Discard changes"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSaveClick,
    size: "medium",
    variant: "contained",
    'custom-attribute': '312-CustomFee'
  }, "Save")))) : null);
};
export default CustomFee;